import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import Organization from "./pages/organization/Organization";
import Operation from "./pages/operation/Operation";
import Semaphore from "./pages/semaphore/Semaphore";
import LegacyRouter from "./LegacyRouter";
import queryString from 'query-string';
import WelcomeTescoCz from "./pages/image/WelcomeTescoCz";
import ScreenImageSk from "./pages/image/ScreenImageSk";

class App extends Component {

    parseParams(props) {
        let query = queryString.parse(props.location.search);

        let token = localStorage.getItem('token') || "";
        let tokenParam = query.token;
        if (tokenParam && tokenParam !== token) {
            localStorage.setItem('token', tokenParam);
            token = tokenParam;
        }

        let hideNumbers = localStorage.getItem('hideNumbers');
        let hideNumbersParam = query.hideNumbers ? query.hideNumbers : "false";
        if(hideNumbersParam && hideNumbersParam !== hideNumbers) {
            localStorage.setItem('hideNumbers', hideNumbersParam);
            hideNumbers = hideNumbersParam;
        }

        props.token = token;
        props.language = query.language;
        props.deviceId = query.deviceId;
        props.hideNumbers = (hideNumbers === 'true');
        props.template = query.template || 'default';

        return props;
    }

    render() {
        const App = () => (
            <div>
                <Switch>
                    <Route path='/organization/:organizationId'
                           render={(props) => <Organization {...this.state} {...this.parseParams(props)}/>}/>
                    <Route path='/operation/:operationId'
                           render={(props) => <Operation {...this.state} {...this.parseParams(props)}/>}/>
                    <Route path='/semaphore/:operationId'
                           render={(props) => <Semaphore {...this.state} {...this.parseParams(props)}/>}/>
                    <Route path='/welcomeTescoCz' render={(props) => <WelcomeTescoCz {...this.state} {...this.parseParams(props)}/>}/>
                    <Route path='/screenImageSk' render={(props) => <ScreenImageSk {...this.state} {...this.parseParams(props)}/>}/>

                    <Route from='/*.html' render={(props) => {
                        this.parseParams(props);
                        return <LegacyRouter {...props}/>
                    }
                    }/>
                </Switch>
            </div>
        )
        return (
            <Switch>
                <App/>
            </Switch>
        );
    }
}

export default App;
